import { ReportFeatures } from '@hcs/types';

export const COMP_SELECT_BUTTON_FEATURES_SALE = [ReportFeatures.CompsSelect];
export const COMP_SELECT_BUTTON_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsSelect,
];
